import React from "react";
import { Star } from "lucide-react";

interface TestimonialCardProps {
  quote: string;
  author: string;
  role?: string;
  rating: number;
  image?: string;
  className?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  author,
  role,
  rating,
  image,
  className,
}) => {
  return (
    <div
      className={`card border border-gray-100 flex flex-col min-h-[220px] h-full ${
        className || ""
      }`}
    >
      <div>
        <div className="flex space-x-1 mb-4">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              size={18}
              className={
                i < rating ? "text-warning fill-warning" : "text-gray-300"
              }
            />
          ))}
        </div>
        <blockquote className="text-gray-700 mb-2">"{quote}"</blockquote>
      </div>
      <div className="flex items-center mt-auto pt-2">
        {image && (
          <img
            src={image}
            alt={author}
            className="w-12 h-12 rounded-full object-cover mr-4"
          />
        )}
        <div>
          <p className="font-semibold text-gray-800">{author}</p>
          {role && <p className="text-sm text-gray-500">{role}</p>}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
